import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

export interface ChatSummaryResponseI {
  summary: string;
}

@Injectable({
  providedIn: 'root',
})
export class ChatSummaryService {
  private url = environment.OMNISMART_API_FLOW_ENGINE;
  private slug = 'chat-summary/';

  constructor(private readonly http: HttpClient) {}

  public generateSummary(chatId: string): Observable<ChatSummaryResponseI> {
    return this.http.post<ChatSummaryResponseI>(`${this.url}${this.slug}generate`, { chatId });
  }
}
